import { Observable, Subject } from 'rxjs'

/**
 * DLITE-5094: thread changes learned over commentary-ws's thread-event socket
 * (a `thread`/`invalidate` event, or a reconnect that may have missed some),
 * as the displayed account ids they touch.
 *
 * Server-side grids with the Comments filter on listen to this (through
 * `refilterOnThreadChanges`) so a row that gains or loses its last open
 * thread enters or leaves the filtered results, now that the drawer's
 * in-app `commentary-threads-changed` event is no longer the only signal.
 * Module-level so the grids' free-function wiring needs no injector.
 */
const liveThreadChanges = new Subject<string[]>()

export const liveThreadChanges$: Observable<string[]> =
  liveThreadChanges.asObservable()

/** Called by CommentaryLiveAccountsService for each live invalidation. */
export function announceLiveThreadChanges(accountIds: string[]): void {
  if (accountIds.length > 0) liveThreadChanges.next(accountIds)
}
